module.exports = __webpack_public_path__ + "img/ZB53详情页_07.3e9ecc2d.jpg";